export const notifications = state => state.snackbar.notifications
